import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, SnackBarService, StateService } from 'src/app/services';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResetPasswordComponent implements OnInit {
  private code: string = null;

  public password: string = null;
  public confirmPassword: string = null;

  public passwordRegexp: RegExp = /^(?=.*[a-zA-Z\d])(?=.*[!@#$%^&*.+-]).{6,}$/gm;

  public forgotPasswordFormSubmited: boolean = false;

  constructor(private router: Router,
    private stateService: StateService,
    private route: ActivatedRoute, private authService: AuthService, private snackBarService: SnackBarService) { }

  // Validation errors
  public passwordsNotEqual: boolean = false;
  public passwordLengthFail: boolean = true;
  public passwordLetterOrNumberFail: boolean = true;
  public passwordSymbolFail: boolean = true;
  public allFieldsRequired: boolean = false;
  public lang: string = null;


  public ngOnInit(): void {

    // Get query param
    this.code = this.route.snapshot.queryParams['code'];
  }
  public vmOnLanguageChange(value: string) {
    this.lang = this.stateService.restore('deviceLang');
  };
  public cancel(): void {
    this.router.navigate(["/login"]);
  }
  public goToZilex() {
    window.open('https://zilex.de', '_blank');
  }

  public validate(): void {
    this.password = this.password.trim()
    if (this.password) {
      if (this.password.length < 6) {
        this.passwordLengthFail = true;
      } else {
        this.passwordLengthFail = false;
      }
      if (!(/[A-Za-z0-9]/.test(this.password))) {
        this.passwordLetterOrNumberFail = true;
      } else {
        this.passwordLetterOrNumberFail = false;
      }
      if (!(/[^A-Za-z0-9]/.test(this.password))) {
        this.passwordSymbolFail = true;
      } else {
        this.passwordSymbolFail = false;
      }
    } else {
      this.passwordLengthFail = true;
      this.passwordSymbolFail = true;
      this.passwordLetterOrNumberFail = true;
    }
  }

  public submitResetPassword(form: NgForm): void {
    this.passwordsNotEqual = false;
    this.passwordLengthFail = false;
    this.passwordLetterOrNumberFail = false;
    this.passwordSymbolFail = false;
    this.allFieldsRequired = false;


    if (!this.password || !this.confirmPassword) {
      this.allFieldsRequired = true;
      return;
    }

    this.password = this.password.trim()
    this.confirmPassword = this.confirmPassword.trim();

    if (this.password && this.confirmPassword) {
      this.passwordsNotEqual = this.password !== this.confirmPassword;

      if (this.passwordsNotEqual) {
        form.form.controls['password'].setErrors({ 'incorrect': true });
        form.form.controls['confirmPassword'].setErrors({ 'incorrect': true });
      } else {
        form.form.controls['password'].setErrors(null);
        form.form.controls['confirmPassword'].setErrors(null);
      }
    }

    if (this.password) {
      if (this.password.length < 6) {
        this.passwordLengthFail = true;
      }
      if (!(/[A-Za-z0-9]/.test(this.password))) {
        this.passwordLetterOrNumberFail = true;
      }
      if (!(/[^A-Za-z0-9]/.test(this.password))) {
        this.passwordSymbolFail = true;
      }
      if (this.password.length < 6 || !(/[A-Za-z0-9]/.test(this.password)) || !(/[^A-Za-z0-9]/.test(this.password))) {
        form.form.controls['password'].setErrors({ 'incorrect': true });
      } else {
        form.form.controls['password'].setErrors(null);
      }
    } else {
      this.passwordLengthFail = true;
      form.form.controls['password'].setErrors({ 'incorrect': true });
    }

    if (form.valid) {

      this.authService.resetPassword(this.password, this.code).subscribe({
        next: () => {
          this.snackBarService.open('Password changed successfully', 2).subscribe({
            next: () => {
              this.router.navigate(['login']);
            }
          });
        },
        error: (error) => {
          this.snackBarService.error(error);
        }
      })

    }

  }
}
